import Vue from 'vue'
import Vuex from 'vuex'

import slides from 'rph-slides-vue/src/store/slides.js'
import auth from 'rph-slides-vue/src/store/auth.js'
import nav from '@/store/nav.js'
import user from '@/store/user.js'

Vue.use(Vuex)

export default new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',
  // strict: true,
  modules: {
    slides,
    auth,
    nav,
    user
  },
  state: {
    gitHash: process.env.GIT_HASH || 'no hash',
    packageVersion: process.env.PACKAGE_VERSION || '0',
    packageName: process.env.PACKAGE_NAME || 'no project name',
    socketConnected: false,
    // selectedRendererId: 'default',
    // rendererStatus: {},
    slideStatusDetails: {},
    dataModuleFulltags: []
  },
  getters: {

  },
  mutations: {
    addDataModuleFulltags (state, val) {
      if (Array.isArray(val)) {
        state.dataModuleFulltags.push(...val)
      } else {
        state.dataModuleFulltags.push(val)
      }
    },
    setSlideStatusDetails (state, status) {
      if (status.renderer && status.renderer.slide) {
        const key = status.renderer.slide.listId + '.' + status.renderer.slide.id
        if (!Object.prototype.hasOwnProperty.call(state.slideStatusDetails, key)) {
          Vue.set(state.slideStatusDetails, key, {})
        }
        if (status.renderer.status !== 'Last Export' || state.slideStatusDetails[key].status !== 'Last Export') {
          Vue.set(state.slideStatusDetails[key], 'renderer', {
            playerId: status.playerId,
            status: status.renderer.status,
            progress: status.renderer.progress,
            startTime: status.renderer.startTime,
            timestamp: status.timestamp
          })
        }
      }
      if (status.processor && status.processor.slide) {
        const key = status.processor.slide.listId + '.' + status.processor.slide.id
        if (!Object.prototype.hasOwnProperty.call(state.slideStatusDetails, key)) {
          Vue.set(state.slideStatusDetails, key, {})
        }
        Vue.set(state.slideStatusDetails[key], 'processor', {
          playerId: status.playerId,
          status: status.processor.status,
          progress: status.processor.progress,
          startTime: status.processor.startTime,
          timestamp: status.timestamp
        })
      }
      if (status.uploader && status.uploader.slide) {
        const key = status.uploader.slide.listId + '.' + status.uploader.slide.id
        if (!Object.prototype.hasOwnProperty.call(state.slideStatusDetails, key)) {
          Vue.set(state.slideStatusDetails, key, {})
        }
        Vue.set(state.slideStatusDetails[key], 'uploader', {
          playerId: status.playerId,
          status: status.uploader.status,
          progress: status.uploader.progress,
          startTime: status.uploader.startTime,
          timestamp: status.timestamp,
          files: status.uploader.files
        })
      }
    },
    setSocketConnected (state, connected) {
      state.socketConnected = connected
    }
    // setRendererStatus (state, status) {
    //   Vue.set(state.rendererStatus, status.playerType, status)
    //   // state.rendererStatus = status
    // },
    // setSelectedRendererId (state, id) {
    //   state.selectedRendererId = id
    //   localStorage.selectedRendererId = id
    // }
  },
  actions: {}
})
